export default function IconChevronLeft({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            className={className}
        >
            <path
                d="M3.93731 7L8.31231 11.375L8.92481 10.7625L5.16231 7L8.92481 3.2375L8.31231 2.625L3.93731 7Z"
                fill="black"
            />
        </svg>
    )
}
